var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{staticClass:"bannerImg",staticStyle:{"width":"100%"},attrs:{"src":require("@/assets/complianceStudy/banner.png")}}),_c('div',{staticClass:"academe flex-row"},[_c('left'),_c('right',{attrs:{"list":_vm.list,"attentionList":_vm.attentionList}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }